$(document).ready(function () {
    const textElement = document.querySelector('.homeintro-btn .btn span');
    const buttonElement = document.querySelector('.homeintro-btn .btn');

    const texts = [
        'Vajad ehitajat?',
        'Vajad transporti?',
        '+ Lisa oma töö siit'
    ];

    let textIndex = 0;
    let charIndex = 0;
    let deleting = false;

    const typeSpeed = 40;
    const deleteSpeed = 10;
    const pauseTime = 1800;

    function typewriter() {
        const currentText = texts[textIndex];

        if (deleting) {
            charIndex--;
            textElement.textContent = currentText.substring(0, charIndex);

            if (charIndex === 0) {
                deleting = false;
                textIndex++;

                setTimeout(typewriter, 300);
                return;
            }

            setTimeout(typewriter, deleteSpeed);

        } else {
            charIndex++;
            textElement.textContent = currentText.substring(0, charIndex);

            if (charIndex === currentText.length) {

                // Final text has finished typing
                if (textIndex === texts.length - 1) {
                    textElement.classList.add('finished');

                    setTimeout(() => {
                        buttonElement.classList.add('pulse');
                    }, 500);

                    return;
                }

                // Wait before deleting current text
                deleting = true;
                setTimeout(typewriter, pauseTime);
                return;
            }

            setTimeout(typewriter, typeSpeed);
        }
    }

    setTimeout(typewriter, 500);

});
